<template>
  <div class="agents-userlist">
    <Row>
        <Col :xs="24" :sm="24">
            <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
                <FormItem>
                    <Input v-model="formItem.key" clearable placeholder="输入关键词查找..."></Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="renderTable('formItem')">查找</Button>
                </FormItem>
            </Form>
        </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
     <div style="margin: 10px;overflow: hidden">
        <div style="float: right;">
            <Page ref="listPage" :total="pages.total" :current="pages.page" :page-size="pages.size" show-elevator show-total @on-change="changePage()"></Page>
        </div>
    </div>
  </div>
</template>

<script>
import UploadThumb from "../common/thumb"
import uploadthumbTwo from "../common/thumb"
export default {
    name: 'agents-userlist',
    data () {
        return {
            id: null,   // 页面agentid
            loading: true,
            dataloading: true,
            title:"",
            pages:{
                page:1,
                size:10
            },
            formItem:{
                'key':'',
            },
            list: [
                {
                    title: 'ID',
                    key: 'id',
                    width:350,
                    render:(h,params)=>{
                        var a = "";
                        if(params.row.users != null && params.row.users.username!=null)
                            a = params.row.users.username;
                        var d = '';
                        if(params.row.users != null && params.row.users.uuid!=null)
                            d = params.row.users.uuid;
                        var e = "";
                        if(params.row.users!=null&& params.row.users.openid!=null)
                            e = params.row.users.openid;
                        var f = "";
                        if(params.row.users!=null&& params.row.users.map_mp_openid!=null)
                            f = params.row.users.map_mp_openid;
                        return h('div',[
                            h('p',{
                                style:{
                                    color: '#3c763d'
                                }
                            },'用户名：'+a),
                            h('p',{
                                style:{
                                    color: '#337ab7'
                                }
                            },'用户ID：'+d),
                            h('p',{
                                style:{
                                    color: '#777'
                                }
                            },'微信ID：'+e),
                            h('p',{
                                style:{
                                    color: '#777'
                                }
                            },'小程序ID：'+f),
                        ]);
                    }
                },
                {
                    title: '昵称',
                    key: 'nickname',
                    width:160,
                },
                {
                    title: '电话',
                    key: 'username',
                    width:120,
                    render:(h,params) => {
                        return h('span',params.row.users.username)
                    }
                },
                {
                    title: '邮箱',
                    key: 'email',
                    width:200,
                },
                {
                    title: '余额',
                    key: 'agent_money',
                    width:100,
                    render:(h,params) => {
                        return h('span','￥' + params.row.useraccount != null ? params.row.useraccount.agent_money : '')
                    }
                },
                {
                    title: '积分',
                    key: 'points',
                    width:100,
                    render:(h,params) => {
                        return h('span',params.row.useraccount != null ? params.row.useraccount.points : '')
                    }
                },
                {
                    title: '最近登陆时间',
                    key: 'updated_at',
                    minWidth:150,
                },
                {
                    title: '注册时间',
                    key: 'created_at',
                    minWidth:150,
                },
                 {
                    title: '修改状态',
                    key: 'status',
                    width:100,
                    render:(h,params)=>{
                        return h('span',params.row.status == 1 ? '正常' : '禁用');
                    }
                },
            ],
            tablelist: [],
            showModalStatus:false,
        }
    },
    created: function () {
            this.id = this.$route.params.id;
            this.getTableList();
            // this.getCateList();
            // this.getSkillList();
            // this.getItemList();
    },
    components: {
        UploadThumb,
        uploadthumbTwo,
    },
    watch:{
        "$route.params.id":function(curVal, oldVal) {
            if (curVal) {
                this.id = curVal;
                this.getTableList();
            }
        }
    },
    methods:{
        getTableList:function(){
          this.$api.agents.agentuserlist({"page":this.pages.page,"size":this.pages.size,id:this.id}).then(res=>{
            this.dataloading = false;
            if(res.code == 200)
            {
                this.tablelist = res.result.list;
                this.pages.total = res.result.total;
                this.$Message.success(res.msg);
            }
          });
          return;
        },
         // 翻页
        changePage() {
            this.pages.page = this.$refs['listPage'].currentPage;
            this.renderTable(1);
        },
        // 筛选
        renderTable:function(name) {
            if (name !=1){
                this.pages.page = 1;
             }
            this.dataloading = true;
            var ps = {
                key:this.formItem.key,
                page:this.pages.page,
                size:this.pages.size,
                id:this.id
            };
            this.$api.agents.agentuserlist(ps).then(res=>{
                this.dataloading = false;
                if(res.code == 200)
                {
                    this.tablelist = res.result.list;
                    for (var i in this.tablelist) {
                    this.tablelist[i].phone = this.tablelist[i].data.phone;
                    // if(this.tablelist[i].intangible.length>1){
                    //     this.tablelist[i].intangibleitem = "";
                    // }else{
                    //     this.tablelist[i].intangibleitem = 2;
                    // }


                    this.tablelist[i].auth_company = this.tablelist[i].data.auth_company;
                    this.tablelist[i].is_undeline = this.tablelist[i].is_undeline==0?"否":"是";
                    this.tablelist[i].cate = this.tablelist[i].cate.name;
                }
                    this.pages.total = res.result.total;
                    this.$Message.success(res.msg);
                }
            });
            return;
        }
    },
}
</script>

<style>
    .demo-drawer-footer{
        width: 100%;
        height: 50px;
        position: absolute;
        bottom: 0;
        left: 0;
        border-top: 1px solid #e8e8e8;
        padding: 10px 16px;
        text-align: right;
        background: #fff;
    }
</style>
